import type { HeadcountConfidence, HeadcountReconciliationResult } from './types'

// Confidence thresholds follow the TSCV reconciliation spec: ≤5% High, ≤20% Medium, >20% Low.
export function computeHeadcountReconciliation(
  extractedCount: number,
  sourceRowCount: number | null | undefined
): HeadcountReconciliationResult | null {
  if (sourceRowCount == null) return null
  if (sourceRowCount === 0 || extractedCount > sourceRowCount) {
    return { extractedCount, sourceRowCount, confidence: 'High' }
  }
  const discrepancy = (sourceRowCount - extractedCount) / sourceRowCount
  const confidence: HeadcountConfidence =
    discrepancy <= 0.05 ? 'High' : discrepancy <= 0.20 ? 'Medium' : 'Low'
  return { extractedCount, sourceRowCount, confidence }
}
